/**
 * @generated SignedSource<<969f19dcf9347b3e08b91ba150d26d16>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventAttendeesOverlap_eventAttendees$data = {
  readonly edges: ReadonlyArray<{
    readonly cursor: string;
    readonly node: {
      readonly user: {
        readonly firstName: string;
        readonly lastName: string;
        readonly " $fragmentSpreads": FragmentRefs<"UserPrimaryPhotoNew_user">;
      } | null | undefined;
    };
  }>;
  readonly " $fragmentType": "EventAttendeesOverlap_eventAttendees";
};
export type EventAttendeesOverlap_eventAttendees$key = {
  readonly " $data"?: EventAttendeesOverlap_eventAttendees$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventAttendeesOverlap_eventAttendees">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventAttendeesOverlap_eventAttendees",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EventAttendeesEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EventAttendee",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "user",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "firstName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lastName",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "UserPrimaryPhotoNew_user"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cursor",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "EventAttendeesConnection",
  "abstractKey": null
};

(node as any).hash = "1a8ea4201ed3b97ecf75d3fa21778b97";

export default node;
